import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { ChallengesMilestoneDataService } from "src/app/core/services/challenges-milestone-data.service";
import { getdateformatService } from "src/app/core/services/get-date-format.service";
import { Globals } from "src/app/core/services/global.service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import {
  ConfirmationDialogBoxComponent,
  DeleteGameDialogBoxComponent,
  SelectionChallengeTypeDialogComponent,
  SuccessDialogComponent,
} from "src/app/shared/components/dialog-box";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";

@Component({
  selector: "app-milestone-summary-view",
  templateUrl: "./milestone-summary-view.component.html",
  styleUrls: [
    "./milestone-summary-view.component.css",
    "../../../campaign/pages/campaign-strategy/campaign-strategy.component.css",
  ],
})
export class MilestoneSummaryViewComponent implements OnInit {
  constructor(
    private _TokenStorageService: TokenStorageService,
    private _WidgetConfigService: WidgetConfigService,
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private _apiCallService: ApiCallService,
    private date_format: getdateformatService,
    private _i18nDynamicTranslate: TranslateDynamicText,
    private global: Globals,
    private _snackBar: SnackbarCollection,
    private ChallengesMilestoneDataService: ChallengesMilestoneDataService,
    private datePipe: DatePipe
  ) {}

  showMoreSegmentButtonStatus: boolean = false;
  challengeData: any = {};
  challengeStatus = "DRAFT";
  qIdOfAccount = null;
  zoomAmount = 100;
  validWidgets;
  appSubscriptionPlan;
  milestoneCount = 0;
  milestoneData: any = [];
  challengeId;
  customerSegmentAndTiers = [];
  buffer;

  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params["challengeId"]) this.challengeId = params["challengeId"];
      else this.router.navigate(["/app/challenges/"]);
    });
    this.getWidgets();

    if (!this.ChallengesMilestoneDataService.getChallengeDetails()) {
      this.getChallengeDetailsApi(this.challengeId).then((res) => {
        this.challengeData = res["body"];
        this.milestoneData = this.global.safeParse(
          this.challengeData?.displayParams
        );
        console.log(Object.keys(this.milestoneData).length);
        if (Object.keys(this.milestoneData).length === 0) {
          this.router.navigate(["app/challenges/create-new"], {
            queryParams: {
              action: "new",
              id: this.challengeId,
            },
          });
          return;
        }
        this.processMilestoneData();
        this.ChallengesMilestoneDataService.setChallengeDetails(
          this.challengeData
        );
        this.ChallengesMilestoneDataService.setMilestoneConfig(
          this.milestoneData
        );
        this.challengeStatus = this.challengeData?.status
          ? this.challengeData.status
          : "DRAFT";
        this.challengeData.scheduledStartTime = this.formatTimestamp(
          res["body"]["executionDate"], 'start'
        );
        this.challengeData.scheduledEndTime = this.formatTimestamp(
          res["body"]["scheduleEndDate"], 'end'
        );

        this.getCustomerSegmentsAndTiers();
      });
    } else {
      this.getCustomerSegmentsAndTiers();
    }

    // this.ChallengesMilestoneDataService.data$.subscribe((data)=>{
    //   this.challengeData = data;
    // });
    // this.ChallengesMilestoneDataService.config$.subscribe((data)=>{
    //   this.milestoneData.push(data);
    //   this.processMilestoneData();
    // });
    this.milestoneData =
      this.ChallengesMilestoneDataService.getMilestoneConfig();
    if (
      !this.milestoneData ||
      typeof this.milestoneData !== "object" ||
      Object.keys(this.milestoneData).length === 0
    ) {
      this.milestoneData = []; // Set it to an empty array if it's invalid
    }
    this.processMilestoneData();
    this.challengeData =
      this.ChallengesMilestoneDataService.getChallengeDetails();
    this.challengeStatus = this.challengeData?.status
      ? this.challengeData.status
      : "DRAFT";
    this.qIdOfAccount =
      this._TokenStorageService.getqId() == "null"
        ? null
        : this._TokenStorageService.getqId();
  }

  formatTimestamp(timestamp: number, type: 'start' | 'end'): string {
    const merchantTimeZone = this._TokenStorageService.getMerchantTimeZone();
  
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: merchantTimeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(timestamp);
  
    const dateParts: any = {};
    parts.forEach((part) => {
      if (part.type !== "literal") {
        dateParts[part.type] = part.value;
      }
    });
  
    const time = type === "start" ? "00:00:00" : "23:59:59";
  
    return `${dateParts.year}-${dateParts.month}-${dateParts.day} ${time}`;
  }
  

  async getWidgets() {
    this.validWidgets = await this._WidgetConfigService.getWidget();
    this.appSubscriptionPlan =
      await this._WidgetConfigService.getAppSubscriptionPlan();
  }

  isCreatorOfChallenge() {
    return this.qIdOfAccount == this.challengeData?.created_by?.qid;
  }

  saveChallenge() {
    this.router.navigate(["/app/challenges"]);
  }
  isChallengeInDraftStatus() {
    return this.challengeStatus == "DRAFT" || this.challengeStatus == "ACTIVE";
  }

  magnify(type) {
    let canvas = document.getElementById("canvas");
    if (type === "ADD") {
      if (this.zoomAmount < 150) {
        this.zoomAmount += 10;
        canvas.style.transform = "scale(" + this.zoomAmount / 100 + ")";
        canvas.style.transformOrigin = "left top";
      }
    } else {
      if (this.zoomAmount > 30) {
        this.zoomAmount -= 10;
        canvas.style.transform = "scale(" + this.zoomAmount / 100 + ")";
        canvas.style.transformOrigin = "left top";
      }
    }
  }

  challengeDetailsDownArrowClicked() {
    let element = document.getElementById("keyboard_arrow_down");
    let element2 = document.getElementById("challenge-config-details");
    if (element.className == "trigger-condition-toggle") {
      element.removeAttribute("class");
      element.setAttribute("class", "trigger-condition-toggle-rotate");
      element2.removeAttribute("class");
      element2.setAttribute("class", "qb-challenge-condition-content-enable");
    } else {
      element.removeAttribute("class");
      element.setAttribute("class", "trigger-condition-toggle");
      element2.removeAttribute("class");
      element2.setAttribute("class", "qb-challenge-condition-content");
    }
  }

  milestoneDetailsDownArrowClicked(i, type) {
    let element = document.getElementById(
      "keyboard_arrow_down" + "-" + type + i
    );
    let element2 = document.getElementById(
      "challenge-config-details" + "-" + type + i
    );
    if (element.className == "trigger-condition-toggle") {
      element.removeAttribute("class");
      element.setAttribute("class", "trigger-condition-toggle-rotate");
      element2.removeAttribute("class");
      element2.setAttribute("class", "qb-challenge-condition-content-enable");
    } else {
      element.removeAttribute("class");
      element.setAttribute("class", "trigger-condition-toggle");
      element2.removeAttribute("class");
      element2.setAttribute("class", "qb-challenge-condition-content");
    }
  }

  checkMoreSegmentButtonStatus(value) {
    this.showMoreSegmentButtonStatus = false;
    let length = 0;
    for (let i = 0; i < value.length; i++) {
      length += value[i].name.length;
      if (i < value.length - 1) {
        length++;
      }
    }
    if (length > 15) {
      return true;
    } else {
      return false;
    }
  }

  showData(event, i, type) {
    event.stopPropagation();
    console.log("segment-popup-" + type + i);
    let element = document.getElementById("segment-popup-" + type + i);
    element.style.display = "flex";
  }

  processMilestoneData() {
    let count = 0;
    this.milestoneData = this.milestoneData?.map((item) => {
      if (item.type === "MILESTONECONFIG") {
        count++;
        return { ...item, milestoneCount: count };
      }
      return item;
    });
  }

  onEdit(data?) {
    if (data) {
      this.ChallengesMilestoneDataService.setSingleMilestoneConfig(data);
      this.router.navigate(["app/challenges/create-new-milestone"], {
        queryParams: {
          type: data.type === "MILESTONECONFIG" ? "MILESTONE" : "REWARD",
          action: "edit",
          nodeId: data.id,
          steps: 2,
          challengeId: this.challengeId,
          status: this.challengeStatus,
        },
      });
    } else {
      this.ChallengesMilestoneDataService.setChallengeDetails(
        this.challengeData
      );
      this.router.navigate(["app/challenges/create-new"], {
        queryParams: {
          action: "edit",
          id: this.challengeId,
          status: this.challengeStatus,
        },
      });
    }
  }

  onDelete(data?: any) {
    if (data) {
      this.handleNodeDeletion(data);
    } else {
      this.confirmChallengeDeletion();
    }
  }

  private handleNodeDeletion(data: any) {
    if (this.milestoneData.length <= 1) {
      this._snackBar.openSnackBar(
        "Every challenge should have at least 1 node.",
        2000
      );
      return;
    }

    this.deleteChallengeNodeApi(data.id).then(
      (res) => {
        if (!res) return;

        const startNodeId = this.removeById(this.milestoneData, data.id);
        this.ChallengesMilestoneDataService.setMilestoneConfig(
          this.milestoneData
        );

        if (startNodeId) {
          this.challengeData.startNodeId = startNodeId;
        }

        this.challengeData.displayParams = JSON.stringify(
          this.global.removeMilestoneConfigApi(this.milestoneData)
        );

        this.updateDisplayParamsApi(this.challengeData).then((res) => {
          if (res) {
            this._snackBar.openSnackBar("Successfully deleted the node.", 2000);
          }
        });
      },
      (err) => {
        this._snackBar.openSnackBar(err.message, 2000);
      }
    );
  }

  private confirmChallengeDeletion() {
    const dialogRef = this.dialog.open(DeleteGameDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "540px",
      data: {
        subject: "Delete Challenge",
        challengeName: this.challengeData.challengeName,
        successButtonText: "Delete",
        cancelButtonText: "Cancel",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        return;
      }

      this.deleteChallengeApi(this.challengeId).then(
        (res) => {
          if (res) {
            this._snackBar.openSnackBar("Challenge Deleted Successfully", 2000);
            this.router.navigate(["/app/challenges"]);
          }
        },
        (err) => {
          this._snackBar.openSnackBar("Challenge Deletion Failed", 2000);
        }
      );
    });
  }

  removeById(dataArray: any[], idToRemove: number): number | null {
    const index = dataArray.findIndex((item) => item.id === idToRemove);
    if (index === -1) {
      console.warn("ID not found");
      return null;
    }

    let nextId: number | null = null;

    // If deleting the first element, get the next element's id (if exists)
    if (index === 0 && dataArray.length > 1) {
      nextId = dataArray[1].id;
    }

    // Remove the element
    dataArray.splice(index, 1);

    return nextId;
  }

  createNewNode() {
    const dialogRef = this.dialog.open(SelectionChallengeTypeDialogComponent, {
      panelClass: "no-padding-dialog-popup",
      height: "auto",
      disableClose: true,
      width: "720px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate(["app/challenges/create-new-milestone"], {
          queryParams: {
            type: result,
            challengeId: this.challengeId,
            previousNodeId: this.getPreviousNode(),
          },
        });
      }
      return;

      // this.disabled = false;
    });
  }

  getPreviousNode() {
    return this.milestoneData[this.milestoneData?.length - 1].id
      ? this.milestoneData[this.milestoneData?.length - 1].id
      : null;
  }

  async getCustomerSegmentsAndTiers() {
    await this._apiCallService.getCustomerSegmentsAndTiers().subscribe(
      (response) => {
        this.customerSegmentAndTiers = response["body"];
        this.renderData(this.challengeData);
      },
      (error) => {}
    );
  }

  constantDataStatus() {
    return new Promise((resolve) => {
      let interval = setInterval(() => {
        if (this.customerSegmentAndTiers) {
          clearInterval(interval);
          this.buffer = true;
          resolve(true);
        }
      });
    });
  }

  getChallengeDetailsApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCallService.getChallengeDetails(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  getDateFormat(type?) {
    return this.date_format.getDateFormat(type);
  }

  getCompletionTime(value) {
    value = typeof value === "string" ? JSON.parse(value) : value;
    if (!value || typeof value !== "object") {
      console.error("Invalid value:", value);
      return "data not available";
    }

    if (!value.type) {
      console.error("Missing 'type' key in value:", value);
      return "data not available";
    }

    switch (value.type) {
      case "CUSTOM":
        return `in ${value.value} days`;
      case "NEXT_7_DAYS":
        return "in next 7 days";
      case "NEXT_30_DAYS":
        return "in next 30 days";
      default:
        return "data not available";
    }
  }

  activateStrategy() {
    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "20%",
      data: {
        subject: "Activate Challenge",
        message: this._i18nDynamicTranslate.transform(
          "Do you wish to Activate the Challenge?",
          ["POS_PAGE"]
        ),
        cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", [
          "POS_PAGE",
        ]),
        successButtonText: this._i18nDynamicTranslate.transform("Activate", [
          "POS_PAGE",
        ]),
        "data-widget": "ACTIVATE CHALLENGE",
        "data-button": "Confirm: Activate Challenge",
        "data-item": "",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.activateStrategyApi(this.challengeId).then((res) => {
          if (res) {
            this.challengeStatus = "SCHEDULED";
            const dialogRef = this.dialog.open(SuccessDialogComponent, {
              panelClass: "no-padding-dialog-popup",
              width: "20%",
              disableClose: true,
              data: {
                message: this._i18nDynamicTranslate.transform(
                  "Your challenge has been activated",
                  ["POS_PAGE"]
                ),
                buttonText: this._i18nDynamicTranslate.transform(
                  "Back to Challenge List",
                  ["POS_PAGE"]
                ),
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.router.navigate(["/app/challenges"]);
              }
            });
          }
        });
      }
    });
  }

  deactivateStrategy() {
    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "20%",
      data: {
        subject: "Deactivate Challenge",
        message: this._i18nDynamicTranslate.transform(
          "Are you sure you want to deactivate this challenge?",
          ["POS_PAGE"]
        ),
        cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", [
          "POS_PAGE",
        ]),
        successButtonText: this._i18nDynamicTranslate.transform("Deactivate", [
          "POS_PAGE",
        ]),
        "data-widget": "ACTIVATE CHALLENGE",
        "data-button": "Confirm: Activate Challenge",
        "data-item": "",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deactivateStrategyApi(this.challengeId).then(
          (res) => {
            if (res) {
              this.challengeStatus = "SCHEDULED";
              const dialogRef = this.dialog.open(SuccessDialogComponent, {
                panelClass: "no-padding-dialog-popup",
                width: "20%",
                disableClose: true,
                data: {
                  message: this._i18nDynamicTranslate.transform(
                    "Your challenge has been deactivated",
                    ["POS_PAGE"]
                  ),
                  buttonText: this._i18nDynamicTranslate.transform(
                    "Back to Challenge List",
                    ["POS_PAGE"]
                  ),
                },
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result) {
                  this.router.navigate(["/app/challenges"]);
                }
              });
            }
          },
          (err) => {
            this._snackBar.openSnackBar("Failed to deactive challenge", 2000);
          }
        );
      }
    });
  }

  activateStrategyApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCallService.activateChallenge(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  deactivateStrategyApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCallService.deactivateChallenge(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  deleteChallengeApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCallService.deleteChallenge(id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  deleteChallengeNodeApi(id) {
    return new Promise((resolve, reject) => {
      this._apiCallService.deleteChallengeNode(this.challengeId, id).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  getDateInTimeZone(timestamp: number, format: "time" | "date"): string {
    return this.global.getDateInTimeZone(timestamp, format);
  }

  updateDisplayParamsApi(data) {
    return new Promise((resolve, reject) => {
      this._apiCallService.updateChallenge(data, this.challengeId).subscribe(
        (res) => {
          console.log(res);
          resolve(res);
        },
        (err) => {
          console.log(err.error);
          reject(err.error);
        }
      );
    });
  }

  getUsageConfiggDetails(data, type) {
    let value = this.global.safeParse(data);
    return value[type];
  }

  async renderData(challengeData) {
    if (await this.constantDataStatus()) {
      let segmentIds = JSON.parse(challengeData["audienceConfig"])[
        "segmentIds"
      ];
      let tierIds = JSON.parse(challengeData["audienceConfig"])["tierIds"];
      let customerIds = JSON.parse(challengeData["audienceConfig"])[
        "customerListIds"
      ];
      let employeeIds = JSON.parse(challengeData["audienceConfig"])[
        "employeeListIds"
      ];
      let excludedSegmentIds = JSON.parse(challengeData["audienceConfig"])[
        "excludedSegments"
      ];
      let excludedTierIds = JSON.parse(challengeData["audienceConfig"])[
        "excludedTiers"
      ];
      let excludedCustomerIds = JSON.parse(challengeData["audienceConfig"])[
        "excludedCustomerList"
      ];
      let excludedEmployeeList = JSON.parse(challengeData["audienceConfig"])[
        "employeeListIds"
      ];
      challengeData.allCustomer = JSON.parse(challengeData["audienceConfig"])[
        "allCustomer"
      ];
      if (this.customerSegmentAndTiers.length > 0) {
        this.challengeData.segments = [];
        // if (!this.challengeData.segments) {
        // }
        if (!this.challengeData.customerCount) {
          this.challengeData.customerCount = JSON.parse(
            challengeData["audienceConfig"]
          ).totalCustomerSize;
        }
        if (!this.challengeData.excludedSegments) {
          this.challengeData.excludedSegments = [];
        }
        if (segmentIds) {
          for (let i = 0; i < segmentIds.length; i++) {
            this.challengeData.segments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === segmentIds[i]
                )
              ]
            );
          }
        }

        if (tierIds) {
          for (let i = 0; i < tierIds.length; i++) {
            this.challengeData.segments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === tierIds[i]
                )
              ]
            );
          }
        }
        if (customerIds) {
          for (let i = 0; i < customerIds.length; i++) {
            this.challengeData.segments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === customerIds[i]
                )
              ]
            );
          }
        }
        if (employeeIds) {
          for (let i = 0; i < employeeIds.length; i++) {
            this.challengeData.segments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === employeeIds[i]
                )
              ]
            );
          }
        }
        if (excludedSegmentIds) {
          for (let i = 0; i < excludedSegmentIds.length; i++) {
            this.challengeData.excludedSegments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === excludedSegmentIds[i]
                )
              ]
            );
          }
        }

        if (excludedTierIds) {
          for (let i = 0; i < excludedTierIds.length; i++) {
            this.challengeData.excludedSegments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === excludedTierIds[i]
                )
              ]
            );
          }
        }
        if (excludedCustomerIds) {
          for (let i = 0; i < excludedCustomerIds.length; i++) {
            this.challengeData.excludedSegments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === excludedCustomerIds[i]
                )
              ]
            );
          }
        }
        if (excludedEmployeeList) {
          for (let i = 0; i < excludedEmployeeList.length; i++) {
            this.challengeData.excludedSegments.push(
              this.customerSegmentAndTiers[
                this.customerSegmentAndTiers.findIndex(
                  (x) => x.id === excludedEmployeeList[i]
                )
              ]
            );
          }
        }
      }
    }
  }
}
